import React, { Component } from 'react';
import GridLayout from 'react-grid-layout';
import CircularProgress from '../Circular/Circular';
import Available from "../../assets/img/available_w.png";
import Allocated from "../../assets/img/allocated_w.png";
import Reserved from "../../assets/img/reserved_w.png";
import ToBeFree from "../../assets/img/to_be_free_w.png";
import Icon from "@material-ui/core/Icon";
import Block from "../../assets/img/block_w.png";
import Warning from "../../assets/img/warning.png"
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import { withStyles } from '@material-ui/core/styles';
import { getSlotsAsync } from '../../services/slots/slots';
import { getOrdersCustomersbyStatusAsync } from '../../services/orders/orders';
import { Description, Today, Update, Info, ViewModule } from '@material-ui/icons';
import Moment from 'react-moment';
import moment from 'moment';
import './style.css';
import { getConfigAsync } from 'services/config';
import Button from "components/CustomButtons/Button.js";
import ExportCsv from "exportCsv.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

Moment.globalMoment = moment
Moment.globalLocale = 'pt-br'

class LockerReport extends Component {

  constructor(props) {
    super(props);
    this.getSlots = this.getSlots.bind(this);
    this.getLockerStructSize = this.getLockerStructSize.bind(this);
    this.groupBy = this.groupBy.bind(this);
    this.compare = this.compare.bind(this);
    this.statusIcon = this.statusIcon.bind(this);
    this.getTempoOcupacao = this.getTempoOcupacao.bind(this);
    this.getValorServico = this.getValorServico.bind(this);
    this.handleClickExportCSV = this.handleClickExportCSV.bind(this);

    this.state = {
      slots: [],
      orders: [],
      config: [],
      weight: 0,
      layout: [],
      columns: 0,
      circular: true,
      showStatus: false,
      AllocatedCount: 0,
      UnavailableCount: 0
    }
  }

  async componentDidMount() {

    let [_slots, _orders, _config] = await Promise.all([
      getSlotsAsync(this.props.lockerId),
      getOrdersCustomersbyStatusAsync(this.props.lockerId, 'allocated'),
      getConfigAsync(),
    ]);

    let { slots, orders } = this.state;

    //let _slots = await getSlotsAsync(this.props.lockerId);

    let AllocatedCount = _slots.filter(sl => sl.status ==='allocated').length;
    let UnavailableCount = _slots.filter(sl => sl.status ==='unavailable').length;

    //let _orders = await getOrdersbyStatusAsync(this.props.lockerId, 'allocated');

    /* _orders.forEach(async element => {
      let customer = await getCustomerAsync(element.customerId);
      element.customer = customer;
      orders.push(element);
    }); */

    _slots.forEach(slot => {
      let order = _orders.find(o => o.slotId ===slot.id);
      slot.order = order ? order : [];
      slots.push(slot);
    });

    //let _config = await getConfigAsync();

    this.setState({ UnavailableCount, AllocatedCount, slots, orders, config: _config });
    this.getSlots();
  }

  getSlots() {
    let { layout, columns, slots } = this.state;

    let grouped = this.groupBy(slots, slot => slot.slotName);

    let maxKey = 0;
    for (var key of grouped.keys()) {
      if (maxKey < parseInt(key.substring(0, 1))) {
        maxKey = parseInt(key.substring(0, 1));
      }
    }
    columns = grouped.size;
    let weight = 3;
    let x = 0;
    for (let i = maxKey; i > 0; i--) {
      let sortedArray = grouped.get(`${i}L`).sort(this.compare);

      let y = 0;
      sortedArray.map((s, index, arr) => {

        if (index > 0)
          y = this.getLockerStructSize(sortedArray[index - 1].size, weight).h + y;

        let size = this.getLockerStructSize(s.size, weight);

        layout.push({
          i: s.slotName, x: x, y, w: size.w, h: size.h,
          static: true, statusIcon: this.statusIcon(s.status),
          color: this.statusColor(s.status),
          status: s.status,
          allocatedAt: s.order.allocatedAt ? s.order.allocatedAt : '-',
          documentValue: (s.order.customer || {}).documentValue
        });
      });
      x = x + weight;

      if (i ===1) {
        for (let dex = 0; dex < maxKey; dex++) {

          let kk = (dex ===0) ? `${dex}C` : `${dex}R`;
          let sortedArray = grouped.get(kk).sort(this.compare);

          let y = 0;

          sortedArray.map((s, index, arr) => {
            if (index > 0)
              y = this.getLockerStructSize(sortedArray[index - 1].size, weight).h + y;

            let size = this.getLockerStructSize(s.size, weight);
            layout.push({
              i: s.slotName, x: x, y, w: size.w, h: size.h,
              static: true, statusIcon: this.statusIcon(s.status),
              color: this.statusColor(s.status),
              status: s.status,
              allocatedAt: s.order.allocatedAt ? s.order.allocatedAt : '-',
              documentValue: (s.order.customer || {}).documentValue
            });
          });

          x = x + weight;
        }
      }
    }

    this.setState({ layout, circular: false, columns, weight });
  }

  groupBy(list, keyGetter) {
    let map = new Map();
    list.forEach((item) => {
      let key = keyGetter(item);
      key = key.substring(0, key.length - 1);

      let collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  compare(a, b) {
    let countA = a.slotName.length;
    let countB = b.slotName.length;
    console.log(a.slotName);
    console.log(b.slotName);
    let intA = countA > 3 ? a.slotName.slice(-2) : a.slotName.slice(-1);
    let intB = countB > 3 ? b.slotName.slice(-2) : b.slotName.slice(-1);

    if (parseInt(intA) < parseInt(intB)) {
      return -1;
    }
    if (parseInt(intA) > parseInt(intB)) {
      return 1;
    }
    return 0;
  }

  getLockerStructSize(size, weight) {

    switch (size) {
      case "small":
        return { w: weight, h: 1 };
      case "medium":
        return { w: weight, h: 2 };
      case "large":
        return { w: weight, h: 3 };
      case "extra-large":
        return { w: weight, h: 4 };
      default:
        return { w: weight, h: 2 };
    }
  }

  statusIcon(status) {
    switch (status) {
      case "available":
        return Available;
      case "reserved":
        return Reserved;
      case "unavailable":
        return Block;
      case "dirty":
        return Warning;
      case "allocated":
        return Allocated;
      default:
        return ToBeFree;
    }
  }

  /*   statusColor(status) {
      switch (status) {
        case "available":
          return '#858585';
        case "reserved":
          return "#919047";
        case "unavailable":
          return "#592F41";
        case "dirty":
          return "#BD644B";
        case "allocated":
          return "#D6B778";
        default:
          return "#BD644B";
      }
    } */

  statusColor(status) {
    switch (status) {
      case "available":
        return '#858585';
      case "reserved":
        return "#ff9800";
      case "unavailable":
        return "#f44336";
      case "dirty":
        return "#ff9800";
      case "allocated":
        return "#4caf50";
      default:
        return "#ff9800";
    }
  }

  getTempoOcupacao(allocatedAt) {
    var now = new Date();
    var datefromAPITimeStamp = (new Date(allocatedAt)).getTime();
    var nowTimeStamp = now.getTime();

    var microSecondsDiff = Math.abs(datefromAPITimeStamp - nowTimeStamp);
    var hourDiff = Math.floor(microSecondsDiff / (1000 * 60 * 60));

    return hourDiff;
  }

  getValorServico(allocatedAt) {
    let tempoOcup = this.getTempoOcupacao(allocatedAt);
    let intervalo = this.state.config.intervalo;
    let valor = this.state.config.valorServico;
    let result = 0;

    if (tempoOcup <= intervalo) {
      return result * valor;
    }
    else {
      result = (parseInt(tempoOcup / intervalo) - 1);
      result += (tempoOcup % intervalo) > 0 ? 1 : 0;
      return result * valor;
    }


  }

  handleClickExportCSV() {
    let { layout } = this.state;
    let data = [];

    layout.map(item => {
      if(item.status ==="allocated")
        data.push({locker: 'Socicam01', porta: item.i, alocadoData: new Date(item.allocatedAt).toLocaleDateString("pt-BR") + ' ' + new Date(item.allocatedAt).toLocaleTimeString("pt-BR"), 
                   tempoOcupação: this.getTempoOcupacao(item.allocatedAt) + ' horas',
                   valorServiço: "R$ " + this.getValorServico(item.allocatedAt),
                   documentoValor: item.documentValue});
    });
    ExportCsv(data);
  }

  render() {
    const { classes } = this.props;
    const { layout, circular, columns, weight, showStatus,
      AllocatedCount, UnavailableCount } = this.state;
    return (
      (circular) ?
        <div className={classes.root}>
          <CircularProgress />
        </div>
        : <>
          <Button color="default" aria-controls="simple-menu" aria-haspopup="true" onClick={this.handleClickExportCSV}>
            Exportar csv
          </Button>
          <GridContainer>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader color="success" stats icon>
                  <CardIcon color="success">
                    <Icon>archive</Icon>
                  </CardIcon>
                  <p className={classes.cardCategory}>Volumes alocados</p>
                  <h3 className={classes.cardTitle}>
                    {AllocatedCount} <small>Volumes</small>
                  </h3>
                </CardHeader>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={3}>
              <Card>
                <CardHeader color="danger" stats icon>
                  <CardIcon color="danger">
                    <Icon>info_outline</Icon>
                  </CardIcon>
                  <p className={classes.cardCategory}>Portas bloqueadas</p>
                  <h3 className={classes.cardTitle}>
                    {UnavailableCount} <small>Portas</small>
                  </h3>
                </CardHeader>
              </Card>
            </GridItem>
          </GridContainer>
          <GridLayout className="react-grid-layout" cols={columns * weight} rowHeight={(weight * 15)} width={(columns * weight) * 50}>
            {layout.map(item => (

              <div onClick={(data) => this.setState({ showStatus: !showStatus })} key={item.i} data-grid={item}>
                <div className="divContainer" style={{ backgroundColor: `${item.color}` }}>
                  <span className="text">{item.i}</span>
                  {item.status ==="allocated" && showStatus ?
                    <div className="divIcons">
                      <div style={{ display: "flex", alignItems: "center" }}><ViewModule /><b>Socicam01</b></div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Today /><b>{(item.allocatedAt) ? <Moment format="DD/MM/YYYY HH:mm:SS">{item.allocatedAt}</Moment> : '-'}</b></div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Update /><b>{(item.allocatedAt) ? this.getTempoOcupacao(item.allocatedAt) + ' horas' : '-'}</b></div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Info /><b>{"R$ " + this.getValorServico(item.allocatedAt)}</b></div>
                      <div style={{ display: "flex", alignItems: "center" }}><Description /><b>{item.documentValue}</b></div>
                    </div>
                    : <img alt={item.i} src={item.statusIcon} />}
                </div>
              </div>
            ))}

          </GridLayout></>
    )
  }
}

export default withStyles(styles)(LockerReport);